/**
 * @fileoverview RateWorkingNote — one muted line saying how a charged rate was
 * arrived at, wherever a rate is shown (MOR-1038 "make it obvious").
 *
 * "Bank and receivership (25% discount on $650/hr) · rates as at 30 Jun 2024".
 * Renders nothing for the ordinary case (a grade rate on Standard), so it only
 * ever draws the eye to the entries that are charged differently.
 *
 * In the entry tables it sits under the narrative, not under the rate: the
 * Rate column is a few characters wide and wrapped the note one word per line
 * (QA-26). There it takes `labelled`, which leads with "Rate:" so the line
 * still reads as being about the rate.
 */

import { cn } from "@/utils/misc";
import {
  describeRateWorking,
  hasRateWorking,
  type RateWorking,
} from "./rateCards.helpers";

export function RateWorkingNote({
  working,
  labelled = false,
  className,
}: {
  working: RateWorking;
  /** Lead with "Rate:" — for when the note is not directly under the rate. */
  labelled?: boolean;
  className?: string;
}) {
  if (!hasRateWorking(working)) return null;
  return (
    <p
      className={cn(
        "text-xs font-normal text-amber-700 dark:text-amber-300",
        className,
      )}
    >
      {labelled && "Rate: "}
      {describeRateWorking(working).join(" · ")}
    </p>
  );
}
